export function getHoursAndMinutesFromMinutes(minutes: number) {
  return { hours: Math.floor(minutes / 60), minutes: minutes % 60 };
}
